import { IOYRadioProps, IOYRadioState } from './const';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';

export default class OYRadio extends OY<IOYRadioProps, IOYRadioState> {
  static displayName = 'OYRadio';

  static defaultProps: Partial<IOYRadioProps> = {
    info: [],
    maxTextLength: 15
  }

  public props: IOYRadioState = {};

  public state = {};

  public $el: JQuery = $();

  public $parent: JQuery;

  $node = {
  }

  constructor(option: IOYRadioProps & { $parent: JQuery }) {
    super();
    const { $parent, ...props } = option;
    this.$parent = $parent;
    this.props = { ...OYRadio.defaultProps, ...this.getAttrProps(), ...props };

    this.bindPropsEvent();
    this.render();
  }

  render() {
    this.$el = $(template({ props: this.props, state: this.state, styles }))
    this.bindAttris()
    this.setNode();
    this.bindEvent();
    this.$parent.replaceWith(this.$el)
    this.$parent = this.$el;
  }

  bindEvent() {
    this.bindClick();
  }

  setNode(): void {

  }

  private bindClick() {
    this.$el.delegate(`.${styles.radio_item}`, 'click', (ev: Event) => {
      const $this = $(ev.currentTarget!);
      if ($this.hasClass(styles.checked)) {
        return;
      }
      // 切换样式
      this.$el.find(`.${styles.radio_item}`).removeClass(styles.checked);
      $this.addClass(styles.checked)

      this.eventEmitter.emit('onChange', $this.data('value'))
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYRadio/index.ts